import { Injectable } from '@angular/core';
import { TableColumn } from '../models/table-columns.interface';

@Injectable({
  providedIn: 'root',
})
export class TableColumnsService {
  constructor() {}
  //TODO: Update columnDef w.r.t response from BE
  pickupReportsTable: Array<TableColumn> = [
    {
      columnDef: 'description',
      header: 'Description'
    },
    {
      columnDef: 'creationDate',
      header: 'Creation Date'
    },
    {
      columnDef: 'expirationDate',
      header: 'Expiration Date'
    },
    {
      columnDef: 'elapsedTime',
      header: 'Elapsed Time'
    },
    {
      columnDef: 'status',
      header: ''
    },
  ];

  pendingReportsTable:  Array<TableColumn> = [
    {
      columnDef: 'description',
      header: 'Description'
    },
    {
      columnDef: 'requestDate',
      header: 'Request Date'
    },
    {
      columnDef: 'createdBy',
      header: 'User Submitted'
    },
    {
      columnDef: 'status',
      header: ''
    },
  ];
  getTableHeaders(table) {
    return this[table];
  }
}
